<template>
  <div v-if="visible" class="modal-overlay" @click.self="closeModal">
    <div class="modal-content">
      <span class="close-btn" @click="closeModal">&times;</span>
      <img :src="img_url" alt="预览图片" v-show="img_show" />
      <video :src="video_src" autoplay loop muted playsinline="true" v-show="video_show"></video>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    img_url: {
      type: String,
      default: ''
    },
    img_show: {
      default: true
    },
    video_show: {
      default: true
    },
    video_src: {
      default: ''
    }
  },
  mounted() {
    window.addEventListener('keydown', this.handleEsc)
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleEsc)
  },
  methods: {
    // 退出
    handleEsc(event) {
      if (event.key === 'Escape') {
        this.closeModal()
      }
      if (event.shiftKey && event.key === 'E') {
        this.closeModal()
      }
    },
    closeModal() {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="less" scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  /* 遮罩层颜色 */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9;
}

.modal-content {
  position: relative;
  display: flex;
  border: 2px solid white;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  overflow: auto;
  scrollbar-width: none;

  img {
    width: auto;
    height: 80%;
  }

  video {
    width: auto;
    height: 80%;
  }

  .close-btn {
    position: absolute;
    width: 50px;
    height: 50px;
    top: 25px;
    right: 25px;
    font-size: 30px;
    text-align: center;
    line-height: 50px;
    color: white;
    cursor: pointer;
    background: black;
    border-radius: 50%;
    opacity: 0.5;
    transition: all 0.5s;

    &:hover {
      transform: scale(1.1);
      transition: all 0.5s;
    }
  }
}
</style>
